import {
    GET_COUNTRY,
    GET_STATE,
    SET_COUNTRY,
    SET_STATE,
    SET_EMAIL,
    SET_ERROR,
    SET_PAGE_LOADING,
    SET_PROCESS_LOADING,
    SET_TOGGLE,
    SET_SUCCESS,
    SET_UPDATE_PASSWORD_ERROR,
    GET_BANKS,
    SET_BANKS,
    UPDATE_BANK_ACCOUNT_DETAILS,
    SET_MODAL,
    SET_404,
    SET_DETAIL_NOT_FOUND,
    SET_RANDOM_ACTION,
    UPLOAD_KYC_WITH_BVN,
    UPLOAD_KYC_WITH_BVN_SUCCESS,
    UPLOAD_KYC_WITH_BVN_FAILURE,
    SET_BUTTON_LOADING
} from './actionTypes';

// LOADING FOR PAGES WITHIN DASHBOARD
export const setPageLoading = data => {
    return {
        type: SET_PAGE_LOADING,
        payload: data
    };
};
export const setProcessLoading = data => {
    return {
        type: SET_PROCESS_LOADING,
        payload: data
    };
};
export const setButtonLoading = data => {
    return {
        type: SET_BUTTON_LOADING,
        payload: data
    };
};
export const setSuccess = data => {
    return {
        type: SET_SUCCESS,
        payload: data
    };
};
export const setError = data => {
    return {
        type: SET_ERROR,
        payload: data
    };
};
export const setEmail = data => {
    return {
        type: SET_EMAIL,
        payload: data
    };
};
export const setToggle = () => {
    return {
        type: SET_TOGGLE
    };
};
export const getCountry = () => {
    return {
        type: GET_COUNTRY
    };
};
export const setCountry = data => {
    return {
        type: SET_COUNTRY,
        payload: data
    };
};
export const getState = data => {
    return {
        type: GET_STATE,
        payload: data
    };
};
export const setState = data => {
    return {
        type: SET_STATE,
        payload: data
    };
};
export const setUpdatePasswordError = data => {
    return {
        type: SET_UPDATE_PASSWORD_ERROR,
        payload: data
    };
};
export const getBanks = data => {
    return {
        type: GET_BANKS
    };
};
export const setBanks = data => {
    return {
        type: SET_BANKS,
        payload: data
    };
};

export const updateBankAccDetails = data => {
    return {
        type: UPDATE_BANK_ACCOUNT_DETAILS,
        payload: data
    };
};
export const setModal = data => {
    return {
        type: SET_MODAL,
        payload: data
    };
};

export const set404 = data => {
    return {
        type: SET_404,
        payload: data
    };
};

export const setDetailsNotFound = data => {
    return {
        type: SET_DETAIL_NOT_FOUND,
        payload: data
    };
};

export const setRandomAction = data => {
    return {
        type: SET_RANDOM_ACTION,
        payload: data
    };
};

// todo: action rearrangement -->
export const uploadKycWithBVN = data => {
    return {
        type: UPLOAD_KYC_WITH_BVN,
        payload: data
    };
};

export const uploadKycWithBVNSuccess = () => {
    return {
        type: UPLOAD_KYC_WITH_BVN_SUCCESS
    };
};

export const uploadKycWithBVNFailure = error => {
    return {
        type: UPLOAD_KYC_WITH_BVN_FAILURE,
        payload: error
    };
};
